import { DOMAIN_TITLE } from '../.env'

// profile
import ProfilePage from '../pages/profile/Profile.vue'
import AlbumsList from '../pages/profile/AlbumsList.vue'
import AlbumCreateEdit from '../pages/profile/AlbumCreateEdit.vue'
import TagsList from '../pages/profile/TagsList.vue'
import Settings from '../pages/profile/Settings.vue'
// gallery
import GalleryPage from '../pages/gallery/Gallery.vue'
import Album from '../pages/album/Album.vue'
import PhotoList from '../pages/album/PhotoList.vue'
import Photo from '../pages/album/Photo.vue'
// tag
import TagPage from '../pages/Tag.vue'
// single pages
import HomePage from '../pages/Home.vue'
import NewsPage from '../pages/News.vue'
import ContactPage from '../pages/Contact.vue'
import AboutPage from '../pages/About.vue'
import LoginPage from '../pages/Login.vue'
import NotFoundPage from '../pages/NotFound.vue'

export const routes = [
  {
    path: '/',
    name: 'index',
    component: HomePage,
    meta: { title: `${DOMAIN_TITLE} | home` }
  },
  {
    path: '/news',
    name: 'news',
    component: NewsPage,
    meta: { title: `${DOMAIN_TITLE} | news` }
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: GalleryPage,
    meta: { title: `${DOMAIN_TITLE} | gallery` }
  },
  {
    path: '/album/:albumId',
    component: Album,
    children: [
      {
        path: '',
        name: 'album-view',
        component: PhotoList,
        props: true,
        meta: { title: DOMAIN_TITLE }
      },
      {
        path: 'photo/:photoId',
        name: 'photo-view',
        component: Photo,
        props: true,
        meta: { title: DOMAIN_TITLE }
      }
    ]
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactPage,
    meta: { title: `${DOMAIN_TITLE} | contact` }
  },
  {
    path: '/profile',
    component: ProfilePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | profile` },
    children: [
      {
        path: '',
        name: 'profile',
        component: AlbumsList
      },
      {
        path: 'albums',
        name: 'profile-albums',
        component: AlbumsList
      },
      {
        path: 'albums/new',
        name: 'profile-albums-new',
        component: AlbumCreateEdit
      },
      {
        path: 'albums/:id/edit',
        name: 'profile-album-edit',
        component: AlbumCreateEdit
      },
      {
        path: 'tags',
        name: 'profile-tags',
        component: TagsList
      },
      {
        path: 'settings',
        name: 'profile-settings',
        component: Settings
      }
    ]
  },
  {
    path: '/tags/:name',
    name: 'tag',
    component: TagPage,
    meta: { title: DOMAIN_TITLE }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutPage,
    meta: { title: `${DOMAIN_TITLE} | about` }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: { title: `${DOMAIN_TITLE} | login` }
  },
  {
    path: '*',
    component: NotFoundPage,
    meta: { title: `${DOMAIN_TITLE} | not found` }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js